import { Hotkey } from "@tanstack/react-hotkeys";
import { MDSTextColor } from "@/mds/components/text";

export enum MDSShortcutKeyCharacter {
  Command = "Command",
  C = "C",
  Slash = "Slash",
  Hashtag = "Hashtag",
  Period = "Period",
  One = "One",
  Space = "Space",
  Dash = "Dash",
  TabArrow = "TabArrow",
  Pipe = "Pipe",
  Backtick = "Backtick",
  GreaterThan = "GreaterThan",
  Enter = "Enter",
  SquareBracketOpen = "SquareBracketOpen",
  SquareBracketClose = "SquareBracketClose",
  Tab = "Tab",
  Escape = "Escape",
}

export interface MDSShortcutKeyProps {
  character: MDSShortcutKeyCharacter;
  inline?: boolean;
  size?: MDSShortcutKeyComboSize;
  color?: MDSTextColor;
  variant?: MDSShortcutKeyVariant;
}

// mirrors the Hotkeys library
export type MDSShortcutKeyComboPlatform = "mac" | "windows" | "linux";

export type MDSShortcutKeyComboSize = "Default" | "Large";
export type MDSShortcutKeyVariant = "Default" | "Tooltip";

export interface MDSShortcutKeyComboProps {
  hotkey: Hotkey;
  size?: MDSShortcutKeyComboSize;
  color?: MDSTextColor;
  variant?: MDSShortcutKeyVariant;
}
